module.exports = __webpack_public_path__ + "static/media/infinite.685b5fd4.svg";